import {CloseableWindow} from "../pro-report/shared/closeable-window";
import {GlobalPositionStrategy, Overlay, OverlayConfig, OverlayRef} from "@angular/cdk/overlay";
import {ComponentPortal, ComponentType} from "@angular/cdk/portal";
import {ComponentRef, EventEmitter, Injectable, Injector, Input} from "@angular/core";
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class OverlayUtils {

  constructor(private overlay: Overlay) {
  }

  public createOverLay<T extends CloseableWindow>(component: ComponentType<T>, injector: Injector, panelClass: string = 'filter-window'): OverlayOptions {
    const conf = new OverlayConfig();
    conf.positionStrategy = this.getGlobalPositionStrategy();
    conf.panelClass = 'filter-window';
    conf.hasBackdrop = true;
    const overlayRef = this.overlay.create(conf);
    const componentPortal = new ComponentPortal<T>(component, null, injector);
    const ref = overlayRef.attach<T>(componentPortal);
    overlayRef.addPanelClass(panelClass);
    overlayRef.backdropClick().subscribe({
      next: next => {
        overlayRef.detach();
      }
    });
    ref.instance.closePanel.subscribe({next: (next:any) => {
        overlayRef.detach();
    }});
    if (panelClass === 'user-notes-filter') {
      return new OverlayOptionsPinned(overlayRef, ref, ref.instance.closePanel, panelClass === 'user-notes-filter' ? new EventEmitter<boolean>() : null);
    } else {
      return new OverlayOptions(overlayRef, ref, ref.instance.closePanel);
    }
  }

  private getGlobalPositionStrategy(): GlobalPositionStrategy {
    const gl = new GlobalPositionStrategy();
    gl.centerHorizontally();
    gl.centerVertically();
    return gl;
  }
}

export class OverlayOptions {
  overlayRef: OverlayRef;
  componentRef: ComponentRef<any>;
  closeObs$: Observable<boolean>;

  constructor(overlayRef: OverlayRef, componentRef: ComponentRef<any>, closeObs$: Observable<boolean>) {
    this.overlayRef = overlayRef;
    this.componentRef = componentRef;
    this.closeObs$ = closeObs$;
  }

}

export class OverlayOptionsPinned extends OverlayOptions {
  switchPin$: Observable<boolean>;
  constructor(overlayRef: OverlayRef, componentRef: ComponentRef<any>, closeObs$: Observable<boolean>, switchPin$: Observable<boolean> = new EventEmitter<boolean>()) {
    super(overlayRef, componentRef, closeObs$);
    this.switchPin$ = switchPin$;
  }
}
